<template>
  <div class="supplier-profile-grid">
    <header class="supplier-profile-grid__header">
      <Skeleton width="30%" height="3rem" />
    </header>

    <main class="supplier-profile-grid__main-content">
      <!-- Company Name Section -->
      <div class="section-block">
        <Skeleton width="20%" height="1.5rem" class="mb-2" />
        <Skeleton height="3rem" />
      </div>

      <!-- Company Description Section -->
      <div class="section-block">
        <Skeleton width="25%" height="1.5rem" class="mb-2" />
        <Skeleton height="10rem" />
      </div>

      <!-- Services Section -->
      <div class="section-block">
        <Skeleton width="15%" height="1.5rem" class="mb-2" />
        <div class="services-list">
          <Skeleton width="8rem" height="2.5rem" class="mr-2" />
          <Skeleton width="8rem" height="2.5rem" class="mr-2" />
          <Skeleton width="8rem" height="2.5rem" />
        </div>
      </div>

      <!-- Location Section -->
      <div class="section-block">
        <Skeleton width="25%" height="1.5rem" class="mb-2" />
        <Skeleton height="6rem" />
      </div>

      <!-- Certifications Section -->
      <div class="section-block">
        <Skeleton width="20%" height="1.5rem" class="mb-2" />
        <div class="certifications-list">
          <Skeleton width="10rem" height="2rem" class="mr-2" />
          <Skeleton width="8rem" height="2rem" class="mr-2" />
          <Skeleton width="12rem" height="2rem" />
        </div>
      </div>

      <!-- Sustainability Goals Section -->
      <div class="section-block">
        <Skeleton width="15%" height="1.5rem" class="mb-2" />
        <div class="sustainability-list">
          <Skeleton width="9rem" height="2rem" class="mr-2" />
          <Skeleton width="11rem" height="2rem" class="mr-2" />
          <Skeleton width="10rem" height="2rem" />
        </div>
      </div>
    </main>

    <aside class="supplier-profile-grid__sidebar">
      <!-- Company Logo Section -->
      <div class="company-logo">
        <Skeleton shape="rectangle" width="100%" height="200px" />
      </div>

      <!-- Company Details -->
      <div class="company-details">
        <!-- Organization Number -->
        <div class="detail-block">
          <Skeleton width="40%" height="1.2rem" class="mb-2" />
          <Skeleton height="2.5rem" />
        </div>

        <!-- Contact Person -->
        <div class="detail-block">
          <Skeleton width="30%" height="1.2rem" class="mb-2" />
          <Skeleton height="2.5rem" />
        </div>

        <!-- Email -->
        <div class="detail-block">
          <Skeleton width="20%" height="1.2rem" class="mb-2" />
          <Skeleton height="2.5rem" />
        </div>

        <!-- Revenue -->
        <div class="detail-block">
          <Skeleton width="25%" height="1.2rem" class="mb-2" />
          <Skeleton height="2.5rem" />
        </div>

        <!-- Number of Employees -->
        <div class="detail-block">
          <Skeleton width="35%" height="1.2rem" class="mb-2" />
          <Skeleton height="2.5rem" />
        </div>
      </div>
    </aside>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";
</script>

<style lang="scss" scoped>
.supplier-profile-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  grid-template-areas:
    "header header"
    "main sidebar";
  padding: 0 2rem;
  background: inherit;
  padding-bottom: 12rem;

  &__header {
    grid-area: header;
    padding-top: 2rem;
  }

  &__main-content {
    grid-area: main;
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  &__sidebar {
    grid-area: sidebar;
    display: flex;
    flex-direction: column;
    gap: 3rem;
    border-radius: 8px;
    background: #fff;
    padding: 1.5rem 1.5rem 4rem 1.5rem;
    height: fit-content;
  }
}

.section-block {
  margin-bottom: 2rem;
}

.services-list,
.certifications-list,
.sustainability-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
}

.detail-block {
  margin-bottom: 2rem;
}

.company-logo {
  margin-bottom: 2rem;
}

.company-details {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
</style>
